import { profileConstants } from 'Constants';
import Request from 'Services/request';
import { toast as toastr } from 'react-toastify';
import { medaiHost } from 'Helpers/apiurl';
import { history } from 'Helpers/history';
import { handleApiError, clearStorage, decryptUserToken } from 'Helpers/index';
import routesPath from 'Constants/routes.constants';

export const profileActions = {
  updateProfile,
  fetchProfile,
  updateProfileImage
};

const redirectToDashboard = (updateProfileObject, login) => {
  if(login === 'login'){
    if(typeof updateProfileObject.permission!='undefined'){
      var obj = JSON.parse(updateProfileObject.permission);
      const entries = Object.entries(obj);
      var firstItem = entries.filter(x => typeof x!==undefined).shift();
      var menu = firstItem.filter(x => typeof x!==undefined).shift();
      localStorage.setItem('permission', menu);
      // history.push(routesPath.root);
    }
  }
}

function updateProfileImage( fileToken) {
  return (dispatch) => {
    dispatch(request({}));
    Request.update(`/profile`,
        { image:fileToken })
      .then(({ data }) => {
        const imageUrl = `${ medaiHost }/${ fileToken }?mf=${ decryptUserToken() }`
        dispatch(success({ image:fileToken,imageUrl }));
        toastr.dismiss();
        toastr.success('Profile image updated successfully.');
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failure(error.toString()));
        }
      });
  };

  function request(profile) { return { type: profileConstants.PROFILE_REQUEST, profile }; }
  function success(profile) { return { type: profileConstants.PROFILE_UPDATE_SUCCESS, profile }; }
  function failure(error) { return { type: profileConstants.PROFILE_FAILURE, error }; }
}

function fetchProfile(login = null) {
  return (dispatch) => {
    dispatch(request({}));
    Request.get('/profile', {})
      .then((response) => {
        const { data } = response;
        const profileDetails = data.shift();
        const imageUrl = `${ medaiHost }/${ profileDetails.image }?mf=${ decryptUserToken() }`
        const updateProfileObject = {
          ...profileDetails,
          imageUrl
        }
        dispatch(success(updateProfileObject));
        redirectToDashboard(updateProfileObject, login)
      })
      .catch((error) => {
        if(error) {
          if(error == 'Profile Not Found'){
            clearStorage();
            history.push(routesPath.root);
          }else{
            handleApiError(error);
            dispatch(failure(error.toString()));
          }
        }
      });
  };

  function request(profile) { return { type: profileConstants.PROFILE_REQUEST, profile }; }
  function success(profile) { return { type: profileConstants.PROFILE_GET_SUCCESS, profile }; }
  function failure(error) { return { type: profileConstants.PROFILE_FAILURE, error }; }
}

function updateProfileRequest(profileObject) {
  return Request.update(`/profile`,
    { ...profileObject })
}

function updateProfile(profileObject) {
  return (dispatch) => {
    dispatch(request({}));

    updateProfileRequest(profileObject)
      .then((response) => {
        const { message } = response;
        dispatch(fetchProfile());
        toastr.dismiss();
        toastr.success(message);
      })
      .catch((error) => {
        if(error) {
          handleApiError(error);
          dispatch(failure(error.toString()));
        }
      });
  };

  function request(profile) { return { type: profileConstants.PROFILE_REQUEST, profile }; }
  function failure(error) { return { type: profileConstants.PROFILE_FAILURE, error }; }
}
